import type { LinkProps } from '@ps/web-shared-components';
import { Link } from '@ps/web-shared-components';
import classNames from 'clsx';
import type React from 'react';

import styles from './HorizontalMenuItem.module.scss';

export interface Props extends LinkProps {
  icon: React.ReactElement;
  isIconOnly?: boolean;
  onClick?: () => void;
  text: React.ReactNode;
  url?: string;
  className?: string;
}

const HorizontalMenuItem: React.FC<Props> = ({
  icon,
  isIconOnly,
  onClick,
  text,
  url,
  isActive = (_, { pathname }) => (url ? pathname.startsWith(url) : false),
  className
}) => {
  const children = (
    <>
      {icon}

      <span className={styles.text}>{text}</span>
    </>
  );

  return (
    <li className={classNames(styles.item, className)}>
      {onClick ? (
        <button
          type="button"
          className={classNames(styles.link, { [styles.iconOnly]: isIconOnly })}
          onClick={onClick}
        >
          {children}
        </button>
      ) : (
        <Link
          isActive={isActive}
          className={classNames(styles.link, { [styles.iconOnly]: isIconOnly })}
          href={url}
          activeClassName={classNames(styles.activeLink)}
        >
          {children}
        </Link>
      )}
    </li>
  );
};

export default HorizontalMenuItem;
